import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Field, Select } from "@conserveit/blocks";
import DynamicFormComponent from "./DynamicFormComponent";

@connect(
  (state) => ({
    isFormDisabled: state.reportGenerator.isFormDisabled,
    sites: state.userSites.sites,
    projects: state.userSites.projects,
  }),
  null,
  null,
  { forwardRef: true }
)
export default class SiteSelect extends DynamicFormComponent {
  static propTypes = {
    isFormDisabled: PropTypes.bool.isRequired,
    selectedProject: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      site: { value: undefined },
      isFormValid: true,
    };
  }

  handleSiteChange = ({ value }) => {
    this.setState({
      site: this.props.sites[value],
      isFormValid: true,
    });
  };

  validate = () => {
    if (!this.state.site || this.state.site.length === 0) {
      this.setState({ isFormValid: false });
      return false;
    }
    return true;
  };

  formatSiteOptions = (sites) =>
    Object.values(sites).map((site) => ({
      value: site.syncoId,
      label: `${site.label} - ${site.address}`, // Decorate the label with site address, for easier identification
    }));

  // NOTE: This method is called by the magic black box ReportGeneratorForm
  // This method returns what will end up being on the payload of the report request.
  // TODO: Make this go away.
  getSelectedValues = () => {
    const { projects } = this.props;
    const { site } = this.state;
    // NOTE: Project Key is added here, as ProjectSelect previously did this, and some reports (might?) use it.
    const projectKey = projects[site.projectId].jira_key;
    return {
      siteName: site.label,
      projectKey,
    };
  };

  render() {
    if (!this.props.sites) return null;

    return (
      <Field
        name="form-select-site"
        label="Site"
        isValid={this.state.isFormValid}
        error={!this.state.isFormValid && "Site is required"}
      >
        {({ name, id, error }) => (
          <Select
            placeholder="Select Site"
            clearable={false}
            error={error}
            name={name}
            id={id}
            disabled={this.props.isFormDisabled}
            onChange={this.handleSiteChange}
            options={this.formatSiteOptions(this.props.sites)}
          />
        )}
      </Field>
    );
  }
}
